import { render, staticRenderFns } from "./TerritoryInputs.vue?vue&type=template&id=76113efe&"
import script from "./TerritoryInputs.vue?vue&type=script&lang=ts&"
export * from "./TerritoryInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports